import React, { useEffect, useState } from 'react';
import { Trophy, Star } from 'lucide-react';
import { api } from '../lib/api';

export const ChampionsBanner = () => {
  const [banner, setBanner] = useState(null);
  useEffect(() => { api.get('/champions-banner').then((r) => setBanner(r.data)).catch(() => setBanner(null)); }, []);
  if (!banner?.enabled) return null;
  return (
    <section className="relative overflow-hidden bg-[#c8102e] text-white border-b-4 border-[#f4b400] pt-20 sm:pt-28" data-testid="champions-banner" aria-label={banner.title}>
      <div className="absolute inset-0 opacity-15 pointer-events-none" style={{ backgroundImage: 'repeating-linear-gradient(135deg, #ffffff 0 6px, transparent 6px 26px)' }} aria-hidden="true" />
      <div className="relative max-w-7xl mx-auto px-6 py-6 sm:py-8 flex flex-col md:flex-row md:items-center gap-5">
        <div className="flex items-center gap-4">
          <div className="w-16 h-16 sm:w-20 sm:h-20 shrink-0 bg-[#f4b400] text-[#0a1f44] flex items-center justify-center shadow-[0_0_0_6px_rgba(244,180,0,0.25)] champions-trophy"><Trophy className="w-9 h-9 sm:w-11 sm:h-11" aria-hidden="true" /></div>
          <div>
            <div className="flex items-center gap-2 font-heading uppercase tracking-[0.35em] text-[10px] text-[#f4b400]"><Star className="w-3 h-3 fill-current" aria-hidden="true" /> Champions <Star className="w-3 h-3 fill-current" aria-hidden="true" /></div>
            <h2 className="font-display text-3xl sm:text-5xl leading-none mt-1 drop-shadow" data-testid="champions-banner-title">{banner.title}</h2>
          </div>
        </div>
        <div className="md:ml-auto md:max-w-md">
          {banner.divisions?.length > 0 && (
            <div className="flex flex-wrap gap-2 mb-2" data-testid="champions-banner-divisions">
              {banner.divisions.map((d) => <span key={d} className="bg-[#0a1f44] text-[#f4b400] font-display text-lg px-3 py-1 border border-[#f4b400]/60">{d}</span>)}
            </div>
          )}
          {banner.subtitle && <p className="text-sm sm:text-base text-white/90 leading-snug" data-testid="champions-banner-subtitle">{banner.subtitle}</p>}
        </div>
      </div>
    </section>
  );
};
